import { render, staticRenderFns } from "./PopUpTrigger.vue?vue&type=template&id=a891d368&"
import script from "./PopUpTrigger.vue?vue&type=script&lang=js&"
export * from "./PopUpTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports